import React, { useState } from 'react'
import CustomFilter from './CustomFilter'
import classNames from '../../../classNames'
import '../../../components/offcanvas.scss'

let timeout

function Search({ className, schemas, fields, onSubmit }) {
    const [showOffcanvas, setShowOffcanvas] = useState(false)

  function onChange(value) {
    const where = {}
    clearTimeout(timeout)
    const or = []
    Object.keys(fields).forEach((field) => {
      const options = fields[field]
      if (options.type === 'String') {
        const query = {}
        query[field] = { $regex: value, $options: 'i' }
        or.push(query)
      } else if (options.type === 'Boolean') {
        const query = {}
        query[field] = value === 'true'
        or.push(query)
      } else if (options.type === 'Pointer') {
        const query = {}
        query[field] = { $eq: value } // Assuming `value` is the object ID to search for
        or.push(query)
      }
    })
    where.$or = or
    timeout = setTimeout(() => {
      onSubmit(where)
    }, 300)
  }

  function onClickFilter() {
    setShowOffcanvas(true)
  }

  return (
    <>
    <div className={classNames('input-group', className)}>
      <i
        className='bi bi-search position-absolute'
        style={{
          zIndex: 10,
          width: '50px',
          height: '50px',
          lineHeight: '40px',
          textAlign: 'center',
        }}
      />
      <input
        onChange={(e) => onChange(e.target.value)}
        type='search'
        className='form-control rounded-pill ps-5 '
        placeholder='Search'
        style={{ width: '100px' }}
      />
      <button
        onClick={onClickFilter}
        className='btn btn-link text-black border-0 p-0 ms-1 d-flex align-items-center'
        type='button'
      >
        <i className='bi bi-filter fs-4 text-primary'></i>
      </button>
    </div>
    {showOffcanvas && (
        <div
          className='offcanvas offcanvas-end offcanvas-custom'
          tabIndex='-1'
        >
          <div className='offcanvas-header p-3 border-bottom'>
            <h5 className='offcanvas-title fw-bold'>filter</h5>
            <button
              type='button'
              className='btn-close text-reset'
              onClick={() => setShowOffcanvas(false)}
            ></button>
          </div>
          <div className='offcanvas-body p-3'>
          <CustomFilter
            onSubmit={(where) => {
                setShowOffcanvas(false)
                onSubmit(where)
            }}
            onCancel={() => setShowOffcanvas(false)}
            />
          </div>
        </div>
      )}
    </>
  )
}

export default Search
